import CloseButton from '~/components/ButtonIcons/CloseButton';

import { ReactComponent as CloseIcon } from '~/assets/images/buttons/darkBlueClose.svg';

const SubscriptionCloseButton = ({ ...props }) => (
  <CloseButton
    CloseIcon={CloseIcon}
    {...props}
  />
);

export default SubscriptionCloseButton;
